import React from 'react';
import { useNavigate } from "react-router-dom";
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import TextField from '@mui/material/TextField';
// import InputAdornment from '@mui/material/InputAdornment';
// import SavedSearchIcon from '@mui/icons-material/SavedSearch';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import axios from 'axios';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {
  const navigate = useNavigate();
  const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [channelId, setChannelId] = React.useState(0);
  const [channelName, setChannelName] = React.useState("");

  const [status, setStatus] = React.useState("");
  const [ownerAlias, setOwnerAlias] = React.useState("");
  const [ownerId, setOwnerId] = React.useState(0);
  const [parent, setParent] = React.useState("Pipeline");
  const [checkedKanban, setCheckedKanban] = React.useState(true);
  const [orderKanban, setOrderKanban] = React.useState(1);
  const [orderKanbanOld, setOrderKanbanOld] = React.useState(0);

  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

  

  const handleChangeKanban = (event) => {
    setCheckedKanban(event.target.checked);
  };

  React.useEffect(() => {	    
    if(props.dataObj!=null && props.dataObj.autoId && open){	
      setChannelId(props.dataObj.channelId);
      setChannelName(props.dataObj.channelName);
      setStatus(props.dataObj.status);
      setOwnerAlias(props.dataObj.ownerAlias);
      setOwnerId(props.dataObj.ownerId);
      setParent(props.dataObj.parentStatus);
      setOrderKanban(props.dataObj.orderKanban);
      setOrderKanbanOld(props.dataObj.orderKanban);
      if(props.dataObj.activeKanban===1){
        setCheckedKanban(true);
      }else{
        setCheckedKanban(false);
      }
    }else{
      setChannelId(0);
      setChannelName("");
      setStatus("");
      setOwnerAlias("");
      setOwnerId(0);
      setParent("Pipeline");
      setOrderKanban(1);
      setCheckedKanban(true);
    }
	}, [props.dataObj,userObj,open]);

	function saveData(){

    if(!channelId){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Select channel");			
      return false;
    }

    if(!status){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter status");			
      return false;
    }
    
		if(channelId && channelId>0 && status && status.length>1){ 
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
					'device': 'web',
					'registerId': userObj.registerId,
					'uid': userObj.loginId,
					'fullName': userObj.fullName,
					'token': userObj.token,
				}
			}; 
			const data = new FormData();
      if(props.dataObj && props.dataObj.autoId){
        data.append('id', props.dataObj.autoId);
      }
      data.append('channelId', channelId);
      data.append('channelName', channelName);
      data.append('status', status);
      data.append('parentStatus', parent);      
      data.append('orderKanban', orderKanban);

      if(ownerId && ownerAlias && ownerId>0 && ownerAlias.length>0){
        data.append('ownerAlias', ownerAlias);
        data.append('ownerId', ownerId);
      }else{
        data.append('ownerAlias', '');
        data.append('ownerId', '');
      }

      if(checkedKanban===true){
        data.append('activeKanban', 1);
      }else{
        data.append('activeKanban', 0);
      }

      if(orderKanbanOld!==orderKanban && props.dataObj && props.dataObj.autoId){
        data.append('changeFlag', 1);
      }else{
        data.append('changeFlag', 0);
      }
      
      let apiURL='/crm-create-lead-status';
      let myMessage="Status has been created.";
      if(props.dataObj && props.dataObj.autoId){
          apiURL='/crm-update-lead-status';
          myMessage="Status has been updated.";
      }
             
			axios.post(API_URL+apiURL, data, axiosHeader)
			.then((response) => {
				///console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage(myMessage);
          window.location.reload();	
					return false;
        }else if(response.data.responseTxt==="alreadyexistserror"){
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage("This lead status was created earlier. Kindly enter another lead status.");
            return false;  		
        }else if(response.data.responseTxt==="invalidtoken"){
            navigate('/invalidtoken');  
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("This lead status could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage(""+error);			
					return false;
			})	
		}		
	}
  
  function handleChannel(id) {
    if(props.channels && props.channels.length>0){
      for(let i=0; i<props.channels.length; i++){
        if(props.channels[i].autoId===id){
          setChannelId(id);
          setChannelName(props.channels[i].channelName);
          break;
        }
      }
    }
  }


  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent >
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{props.dataObj!=null?<>Edit</>:<>New</>} Lead Status</h3></div>
                  <p>
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                      <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td width={'40%'}>Channel</td>
                            <td>
                                <Select 
                                  fullWidth
                                  value={channelId}                                  
                                  variant="standard"
                                  onChange={event => handleChannel(event.target.value)}
                                >
                                  <MenuItem value={0}>Select Channel</MenuItem>
                                  {props.channels?props.channels.map((myRow,mykey)=>(
                                    <MenuItem key={'cat'+mykey} value={myRow.autoId}>{myRow.channelName}</MenuItem>
                                  )):null}
                                </Select>
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Status</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setStatus(event.target.value)} value={status} placeholder={'Enter Status'} fullWidth variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Parent</td>
                            <td>
                              <Select 
                                  style={{width:'100%'}}                                  
                                  value={parent}									
                                  onChange={event => setParent(event.target.value)}
                                  variant="standard"
                                >
                                    <MenuItem value="Pipeline">Pipeline</MenuItem>
                                    <MenuItem value="Best-Lead">Best-Lead</MenuItem>
                                    <MenuItem value="Committed">Committed</MenuItem>
                                    <MenuItem value="Won">Won</MenuItem>
                                    <MenuItem value="Lost">Lost</MenuItem>
                                    <MenuItem value="Invalid">Invalid</MenuItem>
                              </Select>
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Sequence Number</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setOrderKanban(event.target.value)} value={orderKanban} placeholder={'Enter sequence number'} fullWidth variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Kanban</td>
                            <td  >
                                <Checkbox
                                  checked={checkedKanban}
                                  onChange={handleChangeKanban}
                                  inputProps={{ 'aria-label': 'controlled' }}
                                />
                                Show in Kanban List
                            </td>                            
                        </tr>

                      </table>

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          <Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF'}} >Save</Button>
								      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>


    </>
  );

});

export default CustomizedDialogs;